import { render, staticRenderFns } from "./switchAddress.vue?vue&type=template&id=9ec1dea6&scoped=true&"
import script from "./switchAddress.vue?vue&type=script&lang=js&"
export * from "./switchAddress.vue?vue&type=script&lang=js&"
import style0 from "./switchAddress.vue?vue&type=style&index=0&id=9ec1dea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec1dea6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ec1dea6')) {
      api.createRecord('9ec1dea6', component.options)
    } else {
      api.reload('9ec1dea6', component.options)
    }
    module.hot.accept("./switchAddress.vue?vue&type=template&id=9ec1dea6&scoped=true&", function () {
      api.rerender('9ec1dea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/switchAddress.vue"
export default component.exports